import { RedirectOutbound } from '@modusign/design-system';
import qs from 'qs';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router-dom';
import { useMount } from 'react-use';

import { isAuthenticated } from '@app/store/account/selectors';
import { signOut } from '@app/store/account/sign-out/actions';

function SignOutPage() {
  const isAuth = useSelector(isAuthenticated);
  const dispatch = useDispatch();
  const { search } = useLocation();
  const { redirectTo } = qs.parse(search, { ignoreQueryPrefix: true });

  useMount(() => {
    if (isAuth) {
      dispatch(signOut());
    }
  });

  if (!isAuth) {
    if (redirectTo && typeof redirectTo === 'string') {
      if (redirectTo.startsWith('/')) {
        return <Redirect to={redirectTo} />;
      }
      return <RedirectOutbound to={redirectTo} />;
    }
    return <Redirect to="/authentication/signin" />;
  }
  return null;
}

export default SignOutPage;
